import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useNewTrip } from '../hooks/useNewTrip'
import Loader from './Loader'

const NewTrip = () => {
    const [tripName, setTripName] = useState('')
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const {newTrip, error, isLoading} = useNewTrip()
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()
        
        const success = await newTrip(tripName, startDate, endDate)
        if (success) {
            navigate('/')
        }
    }

    if (isLoading) {
        return <Loader />
    }

    return (
        <form className="new-trip" onSubmit={handleSubmit}>
            <h3>New Trip</h3>
            <label>Trip Name: </label>
            <input type="text" onChange={(e) => setTripName(e.target.value)} value={tripName} />
            <div className="trip-dates">
                <div>
                    <label>Start Date: </label>
                    <input type="date" onChange={(e) => setStartDate(e.target.value)} value={startDate} />
                </div>
                <div>
                    <label>End Date: </label>
                    <input type="date" onChange={(e) => setEndDate(e.target.value)} value={endDate} />
                </div>
            </div>
            <button disabled={isLoading}>Create</button>
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default NewTrip